import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import useUser from '../Context/UserDataContext';
import { nonAdminRoutes, adminRoutes } from '../routes';
import { Select, Breadcrumb } from '@eds/vanilla';
const BreadCrumbs = (props) => {
  const BreadCrumbsref = useRef();
  const CustSelectref = useRef();
  const SiteSelectref = useRef();
  const { data, isLoading } = useUser();
  const [routes, setRoutes] = useState(nonAdminRoutes);
  //const[routeslist,setRouteslist]=useState([])
  let routeslist = [];

  useEffect(() => {
    // Don't render a single breadcrumb.
    if (routes.length <= 1) {
      return null;
    }
    if (!isLoading && data?.data.role[0] === 'ADMIN_ROLE') {
      setRoutes(adminRoutes)
    }
    // const selects = document.querySelectorAll(".select");

    // if (selects) {
    //   Array.from(selects).forEach((selectDOM) => {
    //     const select = new Select(selectDOM);
    //     select.init();
    //   });
    // }
    const breadcrumbElements = BreadCrumbsref.current;
    if (breadcrumbElements) {
      Array.from(breadcrumbElements).forEach((breadcrumbElement) => {
        const iconElement = breadcrumbElement.querySelector('.icon');
        const menuElement = breadcrumbElement.querySelector('.menu');

        iconElement.addEventListener('click', () => {
          if (menuElement.classList.contains('visible')) {
            menuElement.classList.remove('visible');
          } else {
            menuElement.classList.add('visible');
          }
        });

        window.addEventListener('click', (event) => {
          const target = event.target ? event.target : event.srcElement;
          if (target !== breadcrumbElement && !breadcrumbElement.contains(target)) {
            menuElement.classList.remove('visible');
          }
        });
      });
    }
  }, [data?.data, isLoading]);
  routeslist = routes
    .filter(({ path }) => props.match.path.includes(path))
    // Swap out any dynamic routes with their param values.
    // E.g. "/pizza/:pizzaId" will become "/pizza/1"
    .map(({ path, ...rest }) => ({
      path: Object.keys(props.match.params).length
        ? Object.keys(props.match.params).reduce(
            (path, param) => path.replace(`:${param}`, props.match.params[param]),
            path
          )
        : path,
      ...rest
    }));

  return (
    <div className="breadcrumb short" ref={BreadCrumbsref}>
      {/* Link back to any previous steps of the breadcrumb. */}
      {/* <span>
        <div className="select" ref={CustSelectref} data-type="input-multi">
          <div className="clickable current-options">
            <input type="text" placeholder="Select Customer" />
          </div>

          <div className="options-list">
            <div className="item">Customer 1</div>
            <div className="item">Customer 2</div>
            <div className="item">Customer 3</div>
            <div className="item">Customer 4</div>
          </div>
        </div>
        <div className="select" ref={SiteSelectref} data-type="input-single">
          <div className="clickable current-options">
            <input type="text" placeholder="Select Site" />
          </div>

          <div className="options-list">
            <div className="item">Site 1</div>
            <div className="item">Site 2</div>
            <div className="item">Site 3</div>
            <div className="item">Site 4</div>
          </div>
        </div>
      </span> */}

      {routeslist.map(({ name, path }, key) =>
        key + 1 === routeslist.length ? (
          <span key={key}>
            <span className="link">{name}</span>
          </span>
        ) : (
          <span key={key}>
            <Link to={path}>
              <span className="link">{name}</span>
            </Link>
            <span className="separator"></span>
          </span>
        )
      )}
    </div>
  );
};

export default withRouter(BreadCrumbs);
